import { Building2, Search } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { platformApi } from './api'
import type { TenantAnalyticsListItem } from './analytics-types'
import { Status } from './ui'

export function TenantQuickSearch() {
  const navigate = useNavigate()
  const root = useRef<HTMLDivElement>(null)
  const input = useRef<HTMLInputElement>(null)
  const [query, setQuery] = useState('')
  const [results, setResults] = useState<TenantAnalyticsListItem[]>([])
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const keydown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault(); setOpen(true); input.current?.focus()
      } else if (event.key === 'Escape') setOpen(false)
    }
    const pointer = (event: MouseEvent) => { if (!root.current?.contains(event.target as Node)) setOpen(false) }
    document.addEventListener('keydown', keydown); document.addEventListener('mousedown', pointer)
    return () => { document.removeEventListener('keydown', keydown); document.removeEventListener('mousedown', pointer) }
  }, [])
  useEffect(() => {
    if (query.trim().length < 2) { setResults([]); setLoading(false); return }
    let active = true; setLoading(true)
    const timer = window.setTimeout(() => void platformApi.analyticsTenants({ q: query.trim(), page_size: 6, days: 30, sort: 'name', direction: 'asc' })
      .then((result) => { if (active) setResults(result.data) })
      .catch(() => { if (active) setResults([]) })
      .finally(() => { if (active) setLoading(false) }), 220)
    return () => { active = false; window.clearTimeout(timer) }
  }, [query])
  const choose = (tenant: TenantAnalyticsListItem) => { setOpen(false); setQuery(''); navigate(`/tenanti/${tenant.id}`) }
  return <div className="tenant-quick-search" ref={root}><Search size={17} /><input ref={input} aria-label="Brza pretraga tenanta" placeholder="Pronađi tenant…" value={query} onFocus={() => setOpen(true)} onChange={(event) => setQuery(event.target.value)} /><kbd>Ctrl K</kbd>{open && <div className="quick-search-results" role="listbox" aria-label="Rezultati pretrage">{query.trim().length < 2 ? <div className="quick-search-hint"><Building2 size={18} /><span><b>Brza navigacija</b><small>Unesite najmanje dva znaka naziva ili slug-a.</small></span></div> : loading ? <div className="quick-search-hint">Pretraživanje…</div> : results.length ? results.map((tenant) => <button type="button" role="option" aria-selected="false" key={tenant.id} onClick={() => choose(tenant)}><span><b>{tenant.name}</b><small>{tenant.slug} · {tenant.plan_name}</small></span><Status value={tenant.health} /></button>) : <div className="quick-search-hint">Nema pronađenih tenanta.</div>}</div>}</div>
}
